module.exports = __webpack_public_path__ + "img/userB26.8f0448ef.jpg";